var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinMapFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_20324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 33.6C9.93972 33.4137 10.1209 33.2625 10.3292 33.1583C10.5375 33.0542 10.7671 33 11 33H18.5C18.8978 33 19.2794 33.158 19.5607 33.4393C19.842 33.7206 20 34.1022 20 34.5C20 34.8978 19.842 35.2793 19.5607 35.5606C19.2794 35.842 18.8978 36 18.5 36H11.75L5 45H44L37.25 36H30.5C30.1022 36 29.7206 35.842 29.4393 35.5606C29.158 35.2793 29 34.8978 29 34.5C29 34.1022 29.158 33.7206 29.4393 33.4393C29.7206 33.158 30.1022 33 30.5 33H38C38.2329 33 38.4625 33.0542 38.6708 33.1583C38.8791 33.2625 39.0603 33.4137 39.2 33.6L48.2 45.6C48.3671 45.8228 48.4689 46.0878 48.4939 46.3653C48.519 46.6427 48.4662 46.9216 48.3416 47.1708C48.2171 47.42 48.0256 47.6295 47.7886 47.776C47.5516 47.9224 47.2786 48 47 48H2C1.72143 48 1.44837 47.9224 1.2114 47.776C0.97444 47.6295 0.782939 47.42 0.65836 47.1708C0.533781 46.9216 0.481045 46.6427 0.506062 46.3653C0.531079 46.0878 0.63286 45.8228 0.800001 45.6L9.8 33.6Z",
    fill: "#192F51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 12C12.5002 9.69066 13.1668 7.43045 14.4197 5.49056C15.6726 3.55067 17.4586 2.0135 19.5635 1.06351C21.6684 0.113511 24.0027 -0.208957 26.2863 0.134797C28.5699 0.47855 30.7058 1.47392 32.4377 3.00148C34.1696 4.52903 35.424 6.52388 36.0503 8.74665C36.6766 10.9694 36.6482 13.3257 35.9685 15.5327C35.2889 17.7398 33.9869 19.7039 32.2187 21.1893C30.4505 22.6747 28.2912 23.6183 26 23.907V40.5C26 40.8978 25.842 41.2793 25.5607 41.5606C25.2794 41.8419 24.8978 42 24.5 42C24.1022 42 23.7206 41.8419 23.4393 41.5606C23.158 41.2793 23 40.8978 23 40.5V23.91C20.0989 23.5445 17.4311 22.1323 15.4976 19.9387C13.5642 17.7451 12.4983 14.924 12.5 12Z",
    fill: "#192F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_20324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMapFill);
export default __webpack_public_path__ + "static/media/pin-map-fill.9a9ecddbd5ee297b6c94d158bc085639.svg";
export { ForwardRef as ReactComponent };